<i18n>
{
	"no": {
		"yes" : "Ja",
		"no": "Nei"
	},
	"en": {
		"yes" : "Yes",
		"no": "No"
	}

}
</i18n>
<template>
	<t-dialog
		:isShown="isShown"
		:cancelLabel="$t('cancelLabel')"
		:iconType="'bp'"
		:title="title"
		@close="$emit('close')"
		@cancel="$emit('close')"
	>
	
		<div>{{description}}</div>

		<template #footer style="justify-content: center;">
			<div class="button-panel">
				<t-button
					:value="$t('yes')"
					appearance="primary"
					type="bp"
					intent="success"
					iconBefore="tick"
					@click="$emit('yes')"
				/>
				<t-button
					:value="$t('no')"
					appearance="primary"
					type="bp"
					intent="danger"
					iconBefore="cross"
					@click="$emit('close')"
				/>
			</div>
		</template>
	</t-dialog>
</template>

<script>
export default {
	props: {
		title: String,
		description: String,
		isShown: Boolean
	}
};
</script>

<style lang="scss" scoped>
	
.button-panel{
	display:grid;
	grid-template-columns: repeat(2, minmax(max-content, 1fr));
	margin-left: auto;
	column-gap: 1em;
	order: 2;
}
</style>